import React from 'react';
import Image from '@namia/image';
import { Col, Row, Grid } from 'antd';

const { useBreakpoint } = Grid;

const ParallelHighlights = ({ highlights }) => {
  const { md } = useBreakpoint();



  if (md) {
    return (
      <div className="wp-block-kehittamo-block-tr-highlight wp-block-kehittamo-block-tr-highlight--parallel">
        <Row>
          {highlights.map(({ image, cta_link: ctaLink }, index) => {
            const offset = index === 0 ? 0 : 2;
            return (
              <Col span={11} offset={offset} key={`col_${index}`}>
                <div className="parallel-highlight__image">
                  <a href={ctaLink}>
                    <Image
                      alt="alt"
                      base64={image.base64}
                      onError={() => {}}
                      placeholder={image.placeholder}
                      onLoad={() => {}}
                      placeholderBase64={image.placeholderBase64}
                      ratio={image.width / image.height}
                      src={image.src}
                      srcset={image.srcset}
                    />
                  </a>
                </div>
              </Col>
            );
          })}
        </Row>
        <Row>
          {highlights.map(({ title, cta_link: ctaLink }, index) => {
            const offset = index === 0 ? 0 : 2;
            return (
              <Col span={11} offset={offset} key={`col_${index}`}>
                <h1 className="parallel-highlight__title">
                  <a href={ctaLink}>{title}</a>
                </h1>
              </Col>
            );
          })}
        </Row>
        <Row>
          {highlights.map(({ content }, index) => {
            const offset = index === 0 ? 0 : 2;
            return (
              <Col span={11} offset={offset} key={`col_${index}`}>
                <div
                  className="parallel-highlight__content"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </Col>
            );
          })}
        </Row>
        <Row>
          {highlights.map(({ cta_link: ctaLink, cta_text: ctaText }, index) => {
            const offset = index === 0 ? 0 : 2;
            return (
              <Col span={11} offset={offset} key={`col_${index}`}>
                <div className="parallel-highlight__cta kehittamo-block-benedict kehittamo-block-benedict__style kehittamo-block-benedict__style--button-cta">
                  <a className="wp-block-button__link" href={ctaLink}>
                    <div className="wp-block-button">{ctaText}</div>
                  </a>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
  return highlights.map(
    (
      { image, title, content, cta_link: ctaLink, cta_text: ctaText },
      index
    ) => (
      <div
        className={`wp-block-kehittamo-block-tr-highlight wp-block-kehittamo-block-tr-highlight--parallel ${index}`}
      >
        <Row>
          <Col span={24} key={`col_${index}_img`}>
            <div className="parallel-highlight__image">
              <Image
                alt="alt"
                base64={image.base64}
                onError={() => {}}
                placeholder={image.placeholder}
                onLoad={() => {}}
                placeholderBase64={image.placeholderBase64}
                ratio={image.width / image.height}
                src={image.src}
                srcset={image.srcset}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24} key={`col_${index}_cont`}>
            <h1 className="parallel-highlight__title">
              <a href={ctaLink}>{title}</a>
            </h1>
          </Col>
        </Row>
        <Row>
          <Col span={24} key={`col_${index}_cont`}>
            <div
              className="parallel-highlight__content"
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24} key={`col_${`${index}`}_but`}>
            <div className="parallel-highlight__cta kehittamo-block-benedict kehittamo-block-benedict__style kehittamo-block-benedict__style--button-cta">
              <a
                className="wp-block-button__link wp-block-button__link--parallel"
                href={ctaLink}
              >
                <div className="wp-block-button">{ctaText}</div>
              </a>
            </div>
          </Col>
        </Row>
      </div>
    )
  );
};

export default ParallelHighlights;
